import { useMutation } from "@tanstack/react-query";
import { applicationService } from "@/services/applicationService";

// mutations keys
export const applicationsMutationKeys = {
  all: ["applications"],
  list: () => [...applicationsMutationKeys.all, "list"],
  details: (id) => [...applicationsMutationKeys.all, "detail", id],
};


// update application status
export const useUpdateApplicationStatus = (options = {}) => {
  return useMutation({
    mutationFn: ({ applicationIds, status, params }) => 
      applicationService.bulkUpdateApplicationStatus(applicationIds, status, params),
    ...options
  });
};  


// update applications status
export const useUpdateApplicationsStatus = (options = {}) => {
  return useMutation({
    mutationFn: (applications) => applicationService.updateApplicationsStatus(applications),
    ...options
  });
};

// toggle application hold status
export const useToggleApplicationHold = (options = {}) => {
  return useMutation({
    mutationFn: (payload) => 
      applicationService.toggleApplicationHold(payload),
    ...options
  });
};

